import axios from 'axios';
import config from '../env/config'

const BASE_URL = config.BASE_URL; // Replace with your API base URL

// const baseURL='https://api.tameen.om';
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cookies': document.cookie.toString(),
    // Add any additional headers as needed
  },
});
const axiosInstance2 = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'text/plain',
    'Cookies': document.cookie.toString(),
  },
});

// GET request
export const getData = async (endpoint) => {
  try {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    // Handle error
    // throw new Error(error.response.data.error);
  }
};

// POST request
export const postData = async (path, data) => {
  try {
    const response = await axiosInstance.post(config.BASE_URL + path, data, {
      headers: {
        'Cookies': document.cookie.toString(),// Add the cookie to the headers
      },
      validateStatus: false
    });
    // console.log("rrr000000",response);
    return response.data;
  } catch (error) {
    // console.log("rrr000000",error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
};

// POST request
export const postData2 = async (path, data) => {
  try {
    const response = await axiosInstance2.post(config.BASE_URL + path, data, {
      headers: {
        'Cookies': document.cookie.toString(),// Add the cookie to the headers
      },
      validateStatus: false
    });
    // console.log("rrr000000",response);
    return response.data;
  } catch (error) {
    // console.log("rrr000000",error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
};

// PUT request
export const patchData = async (url, data) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return response.data;
  } catch (error) {
    // Handle error
    // throw new Error(error.response.data.error);
  }
};

// DELETE request
export const deleteData = async (id) => {
  try {
    const response = await axiosInstance.delete(`/endpoint/${id}`);
    return response.data;
  } catch (error) {
    // Handle error
    // throw new Error(error.response.data.error);
  }
};

export default axiosInstance; // Export the axios instance for global usage

const url = `${config.CHANNEL_PARTNER_URL}v1/channelPartner/saveGenericData`;
export const postDataApi = async (data) => {
  try {
    const response = await axiosInstance.post(url, data, { validateStatus: false });
    // console.log("hahaaaa",response);
    return response.data;
  } catch (error) {
    console.log(" Error getDataPI ==> ", error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
}

export const getDataApi = async (id) => {

  const getUrl = `${config.CHANNEL_PARTNER_URL}v1/channelPartner/getGenericData/${id}`

  try {
    const response = await axiosInstance.get(getUrl, { validateStatus: false });
    // console.log("get data",response);
    return response.data;
  } catch (error) {
    console.log(" Error getDataPI ==> ", error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
}

export const dynamicPostData = async (path, data) => {
  try {
    const response = await axiosInstance.post(path, data, { validateStatus: false });
    console.log("rrr000000", response);
    return response.data;
  } catch (error) {
    // console.log("rrr000000",error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
};



export const getFundDetails = async (payload) => {
  const getUrl = `${config.CHANNEL_PARTNER_URL}v1/channelPartner/getFundDetails`

  try {
    const response = await axiosInstance.post(getUrl, payload, { validateStatus: false });
    // console.log("get data",response);
    return response.data;
  } catch (error) {
    console.log(" Error getDataPI ==> ", error);

    // Handle error
    // throw new Error(error.response.data.error);
  }
} 